/**
 * RS-3a — how a palette and a board look wherever an attachment is shown.
 *
 * The chip in the firm's thread is dark and the one on the Site Office is
 * paper, so the two surfaces keep their own skins — but the face of an
 * attachment (what the thumbnail is, what the name says, what the micro line
 * underneath says) is decided once, here.
 */
import React from 'react';

const MEDIA = process.env.REACT_APP_BACKEND_URL;

/** A picture address on the attachment, made absolute. */
export const previewSrc = (attachment) => {
  const url = attachment?.preview_public_url || attachment?.preview_url
    || attachment?.thumbnail_url || '';
  if (!url) return '';
  return url.startsWith('http') ? url : `${MEDIA}${url}`;
};

/** Five swatches in a row — the palette, small enough to live in a chip. */
export const SwatchStrip = ({ swatches = [], testId }) => (
  <div className="flex items-center gap-0.5" data-testid={testId}>
    {(swatches.length ? swatches : [{ hex: 'var(--km-paper)' }]).slice(0, 5).map((s, i) => (
      <span
        key={`${s.hex}-${i}`}
        title={[s.name, s.code].filter(Boolean).join(' · ') || s.hex}
        style={{ backgroundColor: s.hex }}
        className="inline-block w-3 h-8 first:rounded-l last:rounded-r"
      />
    ))}
  </div>
);

/** What the chip says about this attachment, whatever kind it is. */
export const attachmentFace = (attachment) => {
  const kind = attachment?.kind;
  if (kind === 'palette') {
    const count = attachment.color_count || (attachment.swatches || []).length;
    return {
      title: attachment.name || attachment.label || 'Palette',
      micro: count ? `palette · ${count} colour${count === 1 ? '' : 's'}` : 'palette',
    };
  }
  if (kind === 'board') {
    return {
      title: attachment.name || attachment.label || 'Board',
      micro: (attachment.board_mode || 'Board').toLowerCase(),
    };
  }
  return { title: attachment?.label || attachment?.name || 'File', micro: kind || 'file' };
};
